<template>
    <div class="market-report snapshot">
        <!-- Market Snapshot title start -->
        <snap-title :title="title" :time="$ft.uppercase(timeRange)" />
        <!-- Market Snapshot title end -->
        <report-mb
            v-if="isMobileSize"
            :soldListing="soldListing"
            :avgSalePrice="avgSalePrice"
            :avgDaysOnMarket="avgDaysOnMarket"
        />
        <report-pc
            v-else
            :soldListing="soldListing"
            :avgSalePrice="avgSalePrice"
            :avgDaysOnMarket="avgDaysOnMarket"
        />
    </div>
</template>

<script>
import ReportPc from './pc';
import ReportMb from './mobile';
import common from '../../../_mixins/market-report/common';
import Title from '../title';

export default {
    name: 'MarketReport',
    mixins: [common],
    components: {
        'report-pc': ReportPc,
        'report-mb': ReportMb,
        'snap-title': Title
    }
};
</script>
